import React from 'react';
import './Layout.css';
import ChatWindow from './ChatWindow';
import HMSNavbarWrapper from './ui/HMSNavbarWrapper';
import CompanyListFailedBanner from './ui/CompanyListFailedBanner';


function Layout({ children, showLeftNavSidebar = true, showRightSidebar = false, chatHeaderText = 'HAMSTIR Deal Builder', isTradeRecap = false, recapType = null, persistOfferId = null, persistRecapId = null }) {
  
  // If navbar is disabled, render without wrapper
  if (!showLeftNavSidebar) {
    return (
      <div className="layout">
        <main className={`main-content ${showRightSidebar ? 'with-right-sidebar' : ''}`}>
          <CompanyListFailedBanner />
          {children}
        </main>
        {showRightSidebar && (
          <aside className="right-sidebar">
            <div className={isTradeRecap ? 'trade-recap-chat-container' : 'floating-element'}>
              <h2 className={isTradeRecap ? 'trade-recap-chat-header' : 'floating-header'}>{chatHeaderText}</h2>
              <ChatWindow isTradeRecap={isTradeRecap} recapType={recapType} persistOfferId={persistOfferId} persistRecapId={persistRecapId} />
            </div>
          </aside>
        )}
      </div>
    );
  }

  return (
    <HMSNavbarWrapper>
      <div className={`layout-content ${showRightSidebar ? 'with-right-sidebar' : ''}`}>
        <main className="main-content">
          <CompanyListFailedBanner />
          {children}
        </main>
        {showRightSidebar && (
          <aside className="right-sidebar">
            <div className={isTradeRecap ? 'trade-recap-chat-container' : 'floating-element'}>
              <h2 className={isTradeRecap ? 'trade-recap-chat-header' : 'floating-header'}>{chatHeaderText}</h2>
              <ChatWindow isTradeRecap={isTradeRecap} recapType={recapType} persistOfferId={persistOfferId} persistRecapId={persistRecapId} />
            </div>
          </aside>
        )}
      </div>
    </HMSNavbarWrapper>
  );
}

export default Layout;